import {SearchableItemService} from "../../../../services/SearchableItemService";

import {textFilterParamsValues} from "../../reactTableController";
export const defaultSortModel = [
    {
        colId: 'bank',
        sort: 'asc',
        sortIndex: 0
    }
];
export const reactReportingAccountCols = function ( translate, userService) {
    return [ {
        field: "accountNumber",
        headerName: translate.instant('ACCOUNT_NUMBER'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "userDefinedAlias1",
        headerName: translate.instant('ACCOUNT_ALIAS'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "shortName",
        headerName: translate.instant('ACCOUNT_NAME'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "currencyCode",
        headerName: translate.instant('CURRENCY'),
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['manualEntryCurrency'])
                    .then(data => params.success(data.map(it => it.code)));
            }
        }
    },{
        field: "bank",
        headerName: translate.instant('BANK'),
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['manualEntryBank'])
                    .then(data => params.success(data.map(it => it.name)));
            }
        }
    }, {
        field: "bic",
        headerName: translate.instant('BIC'),
        sortable: true,
        filter: 'agSetColumnFilter',
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['manualEntryBic'])
                    .then(data => params.success(data.map(it => it.code)));
            }
		}
    }];
}
